export default __webpack_public_path__ + "static/media/lrz_wortbild_d_blau-230.ca64ab29.png";